import React from "react";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import TextChart from "../../../Charts/TextChart";

import {
  fechaFinPeriodoMesActualFunc,
  fechaFinPeriodoMesAnteriorFunc,
  fechaInicioPeriodoMesActualFunc,
  fechaInicioPeriodoMesAnteriorFunc,
} from "../../../../assets/shared/fechas";

const TextoComprasMensuales = (props) => {
  const {
    loading,
    mesActual,
    mesAnterior,
    error,
  } = props;

  const chartSinDatos = error;
  const fechaTitulo = `${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`;
  const isDisabledChart = props.estaOculto;

  return (
    <TextChart
      title={`Compras del mes ${fechaTitulo}`}
      bigAmount={mesActual}
      bigAmountTooltip={`Período ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()} `}
      smallAmount={mesAnterior}
      smallAmountTooltip={`Período ${fechaInicioPeriodoMesAnteriorFunc()} al ${fechaFinPeriodoMesAnteriorFunc()}`}
      loading={loading}
      porcentaje
      bigCurrency
      smallCurrency
      disabled={isDisabledChart}
      border={props.border && !props.error}
      imgSinDatos={chartSinDatos}
      onFiltersClick={() => props.onShowFiltersModal()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.compras.comprasMesComparativo.loading,
    error: state.compras.comprasMesComparativo.error,
    estaCargado: state.compras.comprasMesComparativo.estaCargado,
    mesActual: state.compras.comprasMesComparativo.montoMesActual,
    mesAnterior: state.compras.comprasMesComparativo.montoMesAnterior,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Compras del mes', ['compra']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoComprasMensuales);